import { InsightsListing } from "../components/InsightsListing";
import { loadInsights } from "../lib/insights";
import { seoMeta } from "../lib/seo";
import type { Route } from "./+types/insights-category";

export async function loader({ request, params }: Route.LoaderArgs) {
  const result = await loadInsights(request, params.slug);

  /**
   * A category slug that matches nothing is a 404, not an empty listing. An
   * empty page returning 200 tells a crawler the address is real, and tells a
   * visitor with a mistyped link nothing at all.
   */
  if (!result.insights.categories.some((category) => category.slug === params.slug)) {
    throw new Response("Not Found", { status: 404 });
  }

  return result;
}

export function meta({ loaderData, params, matches }: Route.MetaArgs) {
  const category = loaderData?.insights.categories.find((entry) => entry.slug === params.slug);
  const name = category?.name ?? "Insights";

  return seoMeta({
    matches,
    title: `${name} — Insights — VEO Consultancy`,
    description: `Articles and research from VEO Consultancy on ${name.toLowerCase()}.`,
    path: `/insights/category/${params.slug}`,
    noIndexFollow: (loaderData?.insights.meta.page ?? 1) > 1,
  });
}

export default function InsightsCategory({ loaderData }: Route.ComponentProps) {
  return <InsightsListing {...loaderData} />;
}
